
import Vue from "vue"
import { mapState } from "vuex"

export default Vue.extend({
  layoutProps: {
    titleToken: "price.title",
    isLight: "false",
  },

  computed: {
    ...mapState("app", ["sale"]),

    link () {
      return !this.$auth.loggedIn ? "/registration" : "/account/payment"
    },
  },
})
